/**
 * Service to track metadata versions for Audit History.
 */

export interface MetadataSnapshot {
  title: string;
  description: string;
  tags: string[];
  privacyStatus: string;
}

export interface AuditLog {
  id: string;
  videoId: string;
  videoTitle: string;
  version: number;
  snapshot: MetadataSnapshot;
  timestamp: string;
  changeDescription: string;
}

const STORAGE_KEY = "youtube_version_audit_logs";

export const getAuditLogsForVideo = (videoId: string): AuditLog[] => {
  const allLogs = getAuditLogs();
  return allLogs.filter(log => log.videoId === videoId).sort((a,b) => b.version - a.version);
};

export const getAuditLogs = (): AuditLog[] => {
  const logs = localStorage.getItem(STORAGE_KEY);
  if (logs) return JSON.parse(logs);
  
  // Dummy Initial Data
  return [
    {
      id: "log1",
      videoId: "v1",
      videoTitle: "How to Build a SaaS",
      version: 2,
      changeDescription: "AI SEO Optimization",
      timestamp: new Date(Date.now() - 3600000).toISOString(),
      snapshot: {
        title: "🚀 CRUSH the Algorithm: The Ultimate SaaS Blueprint for 2026",
        description: "Optimized description with keywords...",
        tags: ["SaaS", "AI", "Startup"],
        privacyStatus: "Public"
      }
    },
    {
      id: "log2",
      videoId: "v1",
      videoTitle: "How to Build a SaaS",
      version: 1,
      changeDescription: "Initial Upload",
      timestamp: new Date(Date.now() - 7200000).toISOString(),
      snapshot: {
        title: "How to Build a SaaS",
        description: "Standard description...",
        tags: [],
        privacyStatus: "Private"
      }
    }
  ];
};

export const addAuditLog = (videoId: string, videoTitle: string, snapshot: MetadataSnapshot, description: string) => {
  const logs = getAuditLogs();
  const videoLogs = logs.filter(l => l.videoId === videoId);
  const nextVersion = videoLogs.length > 0 ? Math.max(...videoLogs.map(l => l.version)) + 1 : 1;

  const newLog: AuditLog = {
    id: `log-${Date.now()}`,
    videoId,
    videoTitle,
    version: nextVersion,
    snapshot,
    timestamp: new Date().toISOString(),
    changeDescription: description
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify([newLog, ...logs]));
};
